export default "__VITE_ASSET__oijhJZvE__"